//@ts-ignore
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import {
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
} from "@reduxjs/toolkit";

import {
  cabinetReducer,
} from "pages";
import {
  userDevicesReducer,
  clientOptionsReducer,
  userInfoReducer,
  lessonsReducer,
  loaderReducer,
  modalRestrictionsReducer,
} from "reducers";
import thunk, { ThunkDispatch } from "redux-thunk";

export const history = createBrowserHistory();

const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history as any),
    modalRestrictions: modalRestrictionsReducer,
    userDevices: userDevicesReducer,
    clientOptions: clientOptionsReducer,
    userInfo: userInfoReducer,
    cabinet: cabinetReducer,
    lessons: lessonsReducer,
    loader: loaderReducer,
  });


//@ts-ignore
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  createRootReducer(history as any),
  compose(
    composeEnhancer(
      applyMiddleware(routerMiddleware(history), thunk)
    )
  )
);


export type RootState = ReturnType<typeof store.getState>;
export type TThunkDispatch = ThunkDispatch<RootState, void, any>;
export type TGetState = () => RootState;

export default store;
